export default "__VITE_ASSET__B6xc0$pR__"